var render = function render(){var _vm=this,_c=_vm._self._c;return _c('memlist-card',[_c('m-row',[_c('m-col',{attrs:{"lg":"12"}},[_c('h3',{staticClass:"mt-2",staticStyle:{"color":"#444444"}},[_vm._v("Antal grupper: "+_vm._s(_vm.count))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }